import { configOption, KahunConfigurationOptionType } from "../lib/annotations";

export class SubscriptionOptions {
  @configOption({
    description: "Who is the point of contact of that clinic?",
    displayType: KahunConfigurationOptionType.String,
  })
  contactName: string;
  @configOption({
    description: "What is the point of contact's email address",
    displayType: KahunConfigurationOptionType.String,
  })
  contactEmail: string;
  @configOption({
    description: "Official organization name",
    displayType: KahunConfigurationOptionType.String,
  })
  organizationName: string;
  @configOption({
    description: "How many primary care doctors are in this clinic?",
    displayType: KahunConfigurationOptionType.String,
  })
  numberOfPrimaryCare: string;
  @configOption({
    description: "which ehr system is being used by this clinic",
    displayType: KahunConfigurationOptionType.String,
  })
  ehrSystem: string;
}
